"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
var Severity;
(function (Severity) {
    Severity[Severity["Error"] = 0] = "Error";
    Severity[Severity["Warn"] = 1] = "Warn";
    Severity[Severity["Info"] = 2] = "Info";
    Severity[Severity["Debug"] = 4] = "Debug";
})(Severity = exports.Severity || (exports.Severity = {}));
class LogClient extends authenticated_client_1.AuthenticatedClient {
    log(projectId, message, severity) {
        return __awaiter(this, void 0, void 0, function* () {
            let path = `/v1/projects/${projectId}/log?`;
            if (severity) {
                path = path + `severity=${severity}`;
            }
            const opts = {};
            if (typeof message === 'string') {
                opts.headers = { 'content-type': 'text/plain' };
            }
            yield this.httpPost(path, message, opts);
        });
    }
}
exports.LogClient = LogClient;
//# sourceMappingURL=log.client.js.map